import { render, staticRenderFns } from "./MessageSendStatus.vue?vue&type=template&id=17d0c605&scoped=true&"
import script from "./MessageSendStatus.vue?vue&type=script&lang=js&"
export * from "./MessageSendStatus.vue?vue&type=script&lang=js&"
import style0 from "./MessageSendStatus.vue?vue&type=style&index=0&id=17d0c605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d0c605",
  null
  
)

export default component.exports